import axiosInstance from '../utils/axiosConfig'
import { mobileBackendUrl } from '../env'
import {
  RegularToDirectStatusResponse,
  RegularToDirectSummaryResponse,
  RegularToDirectFundDetailResponse
} from '../types/regular-to-direct-plan.types'

/**
 * Fetches the status of regular to direct plan conversion
 * @returns Promise resolving to status response with regular fund count and additional commissions
 */
export const fetchRegularToDirectStatus = async (): Promise<RegularToDirectStatusResponse> => {
  const response = await axiosInstance.get<RegularToDirectStatusResponse>(
    `${mobileBackendUrl}/v2/portfolio/regular-to-direct/status`
  )
  if (!response?.data) {
    throw new Error('Failed to fetch regular to direct plan status')
  }
  return response.data as RegularToDirectStatusResponse
}

/**
 * Fetches the summary of regular to direct plan conversion
 * Includes list of regular funds with their details
 * @returns Promise resolving to summary response with regular funds list
 */
export const fetchRegularToDirectSummary = async (): Promise<RegularToDirectSummaryResponse> => {
  const response = await axiosInstance.get<RegularToDirectSummaryResponse>(
    `${mobileBackendUrl}/v2/portfolio/regular-to-direct/summary`
  )
  if (!response?.data) {
    throw new Error('Failed to fetch regular to direct plan summary')
  }
  return response.data as RegularToDirectSummaryResponse
}

/**
 * Fetches detailed information for a specific regular fund by ISIN
 * Includes tax details and fund information
 * @param isin - The ISIN of the fund to fetch details for
 * @returns Promise resolving to fund detail response with tax information
 */
export const fetchRegularToDirectFundDetail = async (isin: string): Promise<RegularToDirectFundDetailResponse> => {
  const response = await axiosInstance.get<RegularToDirectFundDetailResponse>(
    `${mobileBackendUrl}/v2/portfolio/regular-to-direct/${isin}`
  )
  if (!response?.data) {
    throw new Error(`Failed to fetch regular to direct plan fund detail for ISIN: ${isin}`)
  }
  return response.data as RegularToDirectFundDetailResponse
}
